/* eslint-disable @typescript-eslint/naming-convention */

export enum STEPS {
  RELACION_DEPENDENCIA_CHOICE,
  UPLOAD_LAST_INCOMES,
  UPLOAD_ARBITRAGE_CERTIFICATION,
  UPLOAD_ARBITRAGE_CEDULAR,
  MONOTRIBUTO_CHOICE,
  UPLOAD_YEAR_INCOME,
  UPLOAD_INCOME_DOC,
  FINAL_STEP_MESSAGE,
}

export enum USER_SELECTION {
  BACK,
  NEXT,
  END,
}

export enum UPLOAD_TYPE {
  ARBITRAGE_CERTIFICATION,
  ARBITRAGE_CEDULAR,
  INCOME,
}
